import { Box } from '@mui/material';
import React from 'react';
import { Helmet } from 'react-helmet-async';

import { DynamicFeatureFlag, useFeatureFlags } from '@sbu/hooks.featureflag';

import { EventPage } from 'app/EventPage';
import { EventPages } from 'app/EventPage/constants';
import { PageLoader } from 'shared/components/elements/Loader';

import { EntitiesContextProvider } from './EntitiesDataGrid/EntitiesContextProvider';
import { EntitiesDataGrid } from './EntitiesDataGrid/EntitiesDataGrid';
import { EntitiesList } from './EntitiesList';

export const EntitiesContainer = () => {
  const { hasAll: isEntitiesListTableEnabled, loading: isLoadingFeatureFlags } =
    useFeatureFlags({
      requestedFlags: [DynamicFeatureFlag.EnableEntitiesListTable],
    });
  const entitiesRef = React.useRef<HTMLDivElement>(null);

  return (
    <>
      <Helmet>
        <title>Entities</title>
      </Helmet>
      <Box ref={entitiesRef} height='100%'>
        {isLoadingFeatureFlags ? (
          <PageLoader />
        ) : isEntitiesListTableEnabled ? (
          <EntitiesContextProvider>
            <EventPage currentPage={EventPages.Entities}>
              <EntitiesDataGrid />
            </EventPage>
          </EntitiesContextProvider>
        ) : (
          <EntitiesList />
        )}
      </Box>
    </>
  );
};
